import React from "react";

export default function Chevron() {
    const svg = `
<svg width="16px" height="28px" viewBox="0 0 16 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
        <g id="Group" transform="translate(8.185628, 14.012236) scale(-1, 1) translate(-8.185628, -14.012236) translate(2.000000, 2.000000)" stroke="#000000" stroke-width="2">
            <line x1="-2.06217089" y1="17.8388595" x2="14.4334263" y2="17.8388305" id="Line-Copy-2" transform="translate(6.185628, 17.838845) scale(-1, -1) rotate(45.000000) translate(-6.185628, -17.838845) "></line>
            <line x1="-2.05702749" y1="6.18714867" x2="14.4282829" y2="6.17683287" id="Line-Copy" transform="translate(6.185628, 6.181991) scale(-1, 1) rotate(45.000000) translate(-6.185628, -6.181991) "></line>
        </g>
    </g>
</svg>`;
    return (
        <i className={'icon'} dangerouslySetInnerHTML={{__html: svg}}/>
    )
}